export default __webpack_public_path__ + "static/media/06.bdc4103c.jpg";